/* eslint-disable  */
import { Checkbox, FormGroup, FormControlLabel } from '@material-ui/core';
import {
  brandList,
  ownBrandList,
  ownCheckedB,
  ownSelectedBrand,
  setOwnCheckedBrandList
} from 'feactures/brand/brandSlice';
import { currentchannel } from 'feactures/channel/channelSlice';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const OwnBrandSelectCheckbox = (props) => {
  const { section } = props;
  const dispatch = useDispatch();
  const channel = useSelector(currentchannel);
  const allBrandList = useSelector(brandList);
  const allOwnBrandList = useSelector(ownBrandList);
  const selectOwnBrand = useSelector(ownSelectedBrand);
  const checkedOwnBrand = useSelector(ownCheckedB);
  let chBrandList = [];
  let current_channel_checked_brand = '';
  if (channel == 1) {
    chBrandList = allOwnBrandList.amazon;
    current_channel_checked_brand = checkedOwnBrand.amazon.brand;
  } else if (channel == 2) {
    chBrandList = allBrandList.rakuten;
    current_channel_checked_brand = checkedOwnBrand.rakuten.brand;
  } else if (channel == 3) {
    chBrandList = allBrandList.yahoo;
    current_channel_checked_brand = checkedOwnBrand.yahoo.brand;
  }

  const sanitizeBrandList = (list, checkedName) =>
    list
      // brand_name が null, undefined, 空文字, '0' の場合は除外
      .filter((item) => {
        const name = item?.brand_name;
        return (
          name !== null && name !== undefined && name !== '' && name !== '0'
        );
      })
      .map((item) => ({
        brand: item.brand_name,
        id: item.brand_id,
        isChecked: checkedName === item.brand_name
      }));

  const [checked, setChecked] = useState(
    sanitizeBrandList(chBrandList, current_channel_checked_brand)
  );

  useEffect(() => {
    let list = [];
    if (channel == 1) {
      list = allOwnBrandList.amazon;
    } else if (channel == 2) {
      list = allBrandList.rakuten;
    } else if (channel == 3) {
      list = allBrandList.yahoo;
    }
    setChecked(sanitizeBrandList(list, current_channel_checked_brand));
  }, [allOwnBrandList, allBrandList, channel, checkedOwnBrand]);

  useEffect(() => {
    const newChecked = checked.map((elem) => {
      let isChecked = false;
      if (channel == 1) {
        isChecked = selectOwnBrand.amazon.brand === elem.brand;
      } else if (channel == 2) {
        isChecked = selectOwnBrand.rakuten.brand === elem.brand;
      } else if (channel == 3) {
        isChecked = selectOwnBrand.yahoo.brand === elem.brand;
      }
      return { ...elem, isChecked };
    });
    setChecked(newChecked);
  }, [channel, selectOwnBrand]);

  const handleChange = (e, brand) => {
    if (e.target.checked) {
      dispatch(setOwnCheckedBrandList({ channel, list: { brand: brand } }));
    } else {
      dispatch(setOwnCheckedBrandList({ channel, list: '' }));
    }
  };

  return (
    <div>
      <FormGroup>
        {checked.map((item, index) => (
          <FormControlLabel
            key={item.id || item.brand} // 安全なkey
            control={
              <Checkbox
                checked={!!item.isChecked}
                onChange={(e) => handleChange(e, item.brand)}
                name={item.brand}
              />
            }
            label={item.brand}
          />
        ))}
      </FormGroup>
    </div>
  );
};

export default OwnBrandSelectCheckbox;
